/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { ApiFetch } from '../../../Utils/ApiFetch';
import { Button } from '@mui/material';
import iconStampedNFT from '../../../Images/nft_stamped.png';
import iconNotStampedNFT from '../../../Images/nft_notstamped.png';
import { Checkbox, Grid } from '@mui/material';
import SplitButton from '../../../Components/Generic/SliptButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/pro-light-svg-icons';
import { useTranslation } from 'react-i18next';
import PopoverErrorMesssage from '../../../Layout/components/verificacion/PopoverErrorMessage';
import { dateSanitizer } from '../../../Helpers/dateFormater';
import { stateRules } from '../../../Helpers/assetHelper';
import { constPaginationDataGrid } from '../../../constants/paginationDataGrid';
import { translateFunc } from '../../../Helpers/translateFunc';
import { simplifyAndTranslateLabels } from '../../../Helpers/simplifyAndTranslateLabels';
import useGlobalContext from '../../../Hooks/useGlobalContext';
import AssetValidationFilter from './AssetValidationFilter';

const AssetValidationTable = (props) => {
  const { t } = useTranslation();
  const { selectedAsset, pageSizeDGs, setPageSizeDGs } = useGlobalContext();
  const [pageSize] = useState(pageSizeDGs);
  const [isInit, setIsInit] = useState(false);
  const [columns, setColumns] = React.useState([]);
  const [errorCell, setErrorCell] = React.useState(null);
  const [errorOpen, setErrorOpen] = React.useState(false);
  const globalContext = useGlobalContext();
  const [rows, setRows] = useState([]);
  const [rawRows, setRawRows] = useState([]);
  const defaultPagination = { field: 'id', sort: 'desc' };
  const [rowCount, setRowCount] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [rowsState, setRowsState] = useState({ page: 0, pageSize: pageSize });
  const [rowCountState, setRowCountState] = useState(rowCount || 0);
  const [sortModel, setSortModel] = useState([defaultPagination]);
  const [filterValues, setFilterValues] = useState([]);
  const filterValuesOnlyAssetsActive = useMemo(() => {
    return [
      ...filterValues,
      {
        field: 'asset_status_change',
        key: 'active',
        value: 'Activo',
        operator: '===',
        name: 'Estado del Token',
      },
    ];
  }, [filterValues]);

  const fieldsToHide = [
    // {
    //   field: 'asset_status_change',
    // },
  ];
  const [filterValuesLoaded, setFilterValuesLoaded] = useState(false);
  const [selectedOption, setSelectedOption] = useState(''); //'all','none','invert','some'
  const [someValue, setSomeValue] = useState(20); // se usa cuando selectedOption==='some'
  const [selectedRows, setSelectedRows] = useState([]);
  const selectedBox = useMemo(() => {
    return (
      props.selectedBox ?? globalContext?.selectedBox ?? { id: -1, subtype: -1 }
    );
  }, [props.selectedBox, globalContext?.selectedBox]);

  const models = JSON.parse(localStorage.getItem('SESSION_DATA'))?.models[
    selectedAsset.id
  ];

  useEffect(() => {
    setRowCountState((prevRowCountState) =>
      rowCount !== undefined ? rowCount : prevRowCountState
    );
  }, [rowCount, setRowCountState]);

  useEffect(() => {
    const cleanedRes = rawRows.map((item) =>
      simplifyAndTranslateLabels(t, item, props.fields)
    );

    setRows(cleanedRes);
  }, [rawRows, t]);

  useEffect(() => {
    setRowCount(undefined);
    loadServerRowsWithoutFilters(0, 5);
    setSelectedRows([]);
  }, [props.url, props.refreshKey]);

  const closeError = () => {
    setErrorCell(null);
    setErrorOpen(false);
  };

  // tododromero: cambiar endpoint
  const loadServerRowsWithoutFilters = async (page, pageSize) => {
    const urlFetch =
      props.statePath === 'transferredAssets' ||
      models?.eventInAssetTransferred?.includes(props.event?.eventType)
        ? `${props.url}/${page}/${pageSize}/${sortModel[0].field}/${sortModel[0].sort}/transferred/${selectedBox.id}/${props.event?.eventType}`
        : `${props.url}/${page}/${pageSize}/${sortModel[0].field}/${
            sortModel[0].sort
          }${props?.isLogicalDeletedPage ? '/deleted' : ''}`;

    if (filterValuesLoaded || true) {
      ApiFetch(
        urlFetch,
        globalContext,
        true,
        async (body) => {
          try {
            let resJson = await body.json();
            props.onChangeRowCount(parseInt(resJson.resTotal));
          } catch (e) {
            //
          }
        },
        (error) => {},
        {
          method: 'POST',
          body: JSON.stringify({ filters: [] }),
        }
      );
    }
  };

  const loadServerRows = async (page, pageSize) => {
    if (filterValuesLoaded) {
      let active = true;

      setIsLoading(true);
      setRowCount(undefined);
      if (sortModel.length === 0) {
        sortModel.push(defaultPagination);
      }

      const urlFetch =
        props.statePath === 'transferredAssets' ||
        models?.eventInAssetTransferred?.includes(props.event?.eventType)
          ? `${props.url}/${page}/${pageSize}/${sortModel[0].field}/${sortModel[0].sort}/transferred/${selectedBox.id}/${props.event?.eventType}`
          : `${props.url}/${page}/${pageSize}/${sortModel[0].field}/${
              sortModel[0].sort
            }${props?.isLogicalDeletedPage ? '/deleted' : ''}`;
      ApiFetch(
        urlFetch,
        globalContext,
        true,
        async (body) => {
          try {
            let resJson = await body.json();

            if (!active) {
              return;
            }

            setRawRows(resJson.res);

            if (selectedBox.id !== -1) {
              setRowCount(resJson.resTotal);
            }

            setIsLoading(false);

            return () => {
              active = false;
            };
          } catch (e) {
            //
          }
        },
        (error) => {},
        {
          method: 'POST',
          body: JSON.stringify({ filters: filterValues }),
        }
      );
    }
  };

  const canRowBeSelected = (params) => {    
    const actualStatus = params.row?.['asset_status_change'];
    return (
      actualStatus === t(`basicFormStepByStep.fieldTranslate.select.asset_status_change.active`)
    );
  };

  useEffect(() => {
    if (props.fields.length === 0) return;
    let ret = [];
    ret.push({
      field: 'selection',
      headerName: '',
      sortable: false,
      width: 10,
      renderCell: (params) => {
        let txPaused = false;
        let txAssetEvent = false;
        let txLogicalDelete = false;

        if (params.row['paused'] != null) {
          if (params.row['paused']) {
            txPaused = true;
          }
        }

        if (props.event?.assetDisabledToEvent) {
          props.event?.assetDisabledToEvent.forEach((condition) => {
            if (
              !txAssetEvent &&
              selectedBox.subtype === condition.box &&
              params.row[condition.params] === condition.value
            ) {
              txAssetEvent = true;
            }
          });
        }

        if (params.row['logical_deleted'] === 1) {
          txLogicalDelete = true;
        }

        let isActiveAsset = canRowBeSelected(params);

        return (
          <Checkbox
            disabled={txPaused || txAssetEvent || txLogicalDelete || !isActiveAsset}
            checked={selectedRows.includes(params.id)}
            onChange={() => {
              handleRowSelection(params.id);
            }}
          />
        );
      },
    });

    if (props.qrMenu && (models?.QrHide === undefined || !models?.QrHide)) {
      ret.push({
        field: 'qr',
        headerName: '',
        minWidth: '30',
        width: '30',
        sortable: false,
        renderCell: props.qrMenu,
      });
    }

    ret.push({ field: 'id', headerName: 'Id', hide: true });

    for (let field of props.fields) {
      let flagAdd = false;
      if (
        field.permissions.list[props.parentType].includes(
          parseInt(props.parentTypeSubType)
        ) === true
      ) {
        flagAdd = true;
      }

      if (field.hideInList) {
        if (
          field.listInEvent?.includes(props.event?.eventType) ||
          field.listInPath?.includes(props.statePath)
        )
          flagAdd = true;
        else flagAdd = false;
      }

      if (flagAdd) {
        const headerLabel = translateFunc(
          t,
          `basicFormStepByStep.placeholdersTranslate.${field.label}`,
          field.label
        );
        if (field.type === 'file') {
          ret.push({
            field: field.name,
            headerName: headerLabel,
            width: 190,
            renderCell: (params) => {
              let image = <></>;
              if (
                params.row[field.name] != null &&
                params.row[field.name] !== ''
              ) {
                let file = JSON.parse(params.row[field.name]);
                if (file?.originalName) {
                  let originalNameSplit = file.originalName.split('.');
                  if (
                    ['JPG', 'PNG', 'JPEG', 'TIFF', 'BMP'].includes(
                      originalNameSplit[
                        originalNameSplit.length - 1
                      ].toUpperCase()
                    )
                  ) {
                    image = (
                      <img
                        style={{
                          maxWidth: '30px',
                          borderStyle: 'dotted',
                          borderWidth: '1px',
                          verticalAlign: 'middle',
                          marginRight: '5px',
                        }}
                        src={file.publicFileURI}
                        alt=""></img>
                    );
                  }
                }
                const onDownload = () => {
                  const link = document.createElement('a');
                  //link.download = `download.txt`;
                  link.href = file.publicFileURI;
                  link.click();
                };
                if (
                  params.row[field.name] != null &&
                  params.row[field.name] !== ''
                ) {
                  return (
                    <div>
                      {image}
                      <Button
                        sx={{ ml: 2 }}
                        variant="outlined"
                        size="small"
                        startIcon={<FontAwesomeIcon icon={faDownload} />}
                        onClick={() => {
                          onDownload();
                        }}
                        style={{
                          padding: '5px',
                          margin: '5px',
                          fontSize: '12px',
                        }}>
                        {t('largeGrid.button.download')}
                      </Button>
                    </div>
                  );
                }
              }
            },
          });
        } else if (field.type === 'nft_link') {
          ret.push({
            field: 'Id', //field.name,
            headerName: 'Id',
            width: 100,
            renderCell: (params) => {
              if (
                params.row[field.name] === '' ||
                params.row[field.name] == null
              ) {
                return (
                  <>
                    <img
                      alt=""
                      onClick={(e) => {
                        setErrorOpen(true);
                        setErrorCell(e.currentTarget);
                      }}
                      style={{
                        width: '30px',
                        marginLeft: '2px',
                        marginRight: '5px',
                        cursor: 'pointer',
                      }}
                      src={iconNotStampedNFT}
                    />
                    {params.row['id']}
                  </>
                );
              } else {
                return (
                  <>
                    <a
                      target="_BLANK"
                      style={{ marginLeft: '2px', marginRight: '5px' }}
                      href={params.row[field.name]}
                      rel="noreferrer">
                      <img
                        alt=""
                        style={{ width: '30px' }}
                        src={iconStampedNFT}
                      />
                    </a>
                    {params.row['id']}
                  </>
                );
              }
            },
          });
        } else if (field.type === 'paused') {
          ret.push({
            field: field.name,
            headerName: headerLabel,
            width: 150,
            fieldType: field.type,
            renderCell: (params) => {
              if (params.row.paused) {
                return (
                  <Button
                    onClick={(e) => {
                      setErrorOpen(true);
                      setErrorCell(e.currentTarget);
                    }}
                    style={{
                      padding: '0px',
                      paddingTop: '0.2rem',
                      margin: '0px',
                      fontSize: '11px',
                      height: '25px',
                      width: '90%',
                    }}
                    size="small"
                    color="secondary"
                    variant="contained">
                    {t('largeGrid.button.paused')}
                  </Button>
                );
              } else {
                return (
                  <Button
                    style={{
                      padding: '0px',
                      paddingTop: '0.2rem',
                      margin: '0px',
                      fontSize: '11px',
                      height: '25px',
                      width: '90%',
                    }}
                    size="small"
                    color="primary"
                    variant="contained">
                    {t('largeGrid.button.alive')}
                  </Button>
                );
              }
            },
          });
        } else if (field.type === 'date') {
          ret.push({
            field: field.name,
            headerName: headerLabel,
            width: 150,
            fieldType: field.type,
            valueFormatter: (params) => dateSanitizer(params?.value),
          });
        } else if (field.type === 'checkbox') {
          ret.push({
            field: field.name,
            headerName: headerLabel,
            sortable: true,
            width: '120',
            renderCell: (params) => {
              return (
                <Checkbox
                  sx={{ width: '100%' }}
                  id={params.id}
                  disabled={true}
                  checked={params.row[field.name] === 'true' ? true : false}
                />
              );
            },
          });
        } else if (field.type === 'select' && field.buttonInGrid) {
          ret.push({
            field: field.name,
            headerName: headerLabel,
            width: 150,
            justifyContent: 'center',
            renderCell: (params) => {
              let objAssetColor = null;
              let fontAssetColor = null;
              let displayValue = params.row[field.name];
              let colorLabel = null;

              const model = selectedAsset.id;
              const stateRuleFunc = stateRules[model];

              if (stateRuleFunc) {
                const [labelTemp, colorLabelTemp] = stateRuleFunc(
                  t,
                  params.row,
                  false
                );

                displayValue = labelTemp;
                colorLabel = colorLabelTemp;
              }

              field.colorsButton.forEach((asset) => {
                if (!objAssetColor && asset.label === colorLabel) {
                  objAssetColor = asset.color;
                  fontAssetColor = asset.fontColor || 'black';
                }
              });

              if (!objAssetColor)
                objAssetColor = field.defaultColorButton || '#76CC81';
              if (!fontAssetColor) fontAssetColor = 'black';

              let txPaused = false;
              if (field.priorPausedSelection && params.row['paused']) {
                txPaused = true;
              }

              return (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                    height: '100%',
                  }}>
                  <Button
                    color="primary"
                    style={{
                      padding: '0px',
                      paddingTop: '0.2rem',
                      margin: '0px',
                      fontSize: '11px',
                      paddingTop: '0.2rem',
                      background: txPaused ? '#76CC81' : objAssetColor,
                      color: txPaused ? 'white' : fontAssetColor,
                      height: '25px',
                      width: '90%',
                    }}
                    size="medium"
                    variant="contained">
                    {txPaused
                      ? t('largeGrid.button.paused')
                      : displayValue || field.defaultLabel}
                  </Button>
                </div>
              );
            },
          });
        } else if (field.type === 'none') {
          // field.type none no muestra la columna en la tabla de assets.
        } else {
          ret.push({
            field: field.name,
            headerName: headerLabel,
            width: 150,
          });
        }
      }
    }

    setColumns(ret);
    ret.map((ret) => (ret.active = true));
    setIsInit(true);
  }, [props.fields, props.parentTypeSubType, selectedRows, t]);

  useEffect(async () => {
    await loadServerRows(rowsState.page, rowsState.pageSize, sortModel[0]);
  }, [rowsState, props.url, filterValues, filterValuesLoaded, props.refreshKey]);

  useEffect(async () => {
    setRowsState({ ...rowsState, page: 0 });
    await loadServerRows(rowsState.page, rowsState.pageSize, sortModel[0]);
  }, [sortModel]);

  const handleSortModelChange = (newModel) => {
    setSortModel(newModel);
  };

  useEffect(() => {
    handleRowSelection();
    setSelectedOption('');
  }, [selectedOption]);

  useEffect(async () => {
    props.preSelectedRows && setSelectedRows(props.preSelectedRows);
  }, []);

  useEffect(() => {
    props.onSelectedRowsChange && props.onSelectedRowsChange(selectedRows);
  }, [selectedRows]);

  const handleRowSelection = (value) => {
    if (value === undefined) {
      switch (selectedOption) {
        case 'all':
          setIsLoading(true);
          ApiFetch(
            props.statePath === 'transferredAssets' ||
              models?.eventInAssetTransferred?.includes(props.event?.eventType)
              ? `${props.url}/0/-1/${sortModel[0].field}/${sortModel[0].sort}/transferred/${selectedBox.id}/${props.event?.eventType}`
              : `${props.url}/0/-1/${sortModel[0].field}/${sortModel[0].sort}/active`, // page:0 y pageSize: -1 === all registers
            globalContext,
            true,
            async (body) => {
              let resJson = await body.json();
              let auxRowsIds = resJson.res.map((o) => o.id);
              setSelectedRows(auxRowsIds);
              setIsLoading(false);
            },
            (error) => {
              setIsLoading(false);
            },
            {
              method: 'POST',
              body: JSON.stringify({
                filters: filterValuesOnlyAssetsActive,
                outputFields: ['id'],
                eventType: props.event?.eventType,
                boxType: selectedBox.subtype,
              }),
            }
          );
          break;
        case 'none':
          setSelectedRows([]);
          break;
        case 'invert':
          setIsLoading(true);
          ApiFetch(
            props.statePath === 'transferredAssets' ||
              models?.eventInAssetTransferred?.includes(props.event?.eventType)
              ? `${props.url}/0/-1/${sortModel[0].field}/${sortModel[0].sort}/transferred/${selectedBox.id}/${props.event?.eventType}`
              : `${props.url}/0/-1/${sortModel[0].field}/${sortModel[0].sort}/active`, // page:0 y pageSize: -1 === all registers
            globalContext,
            true,
            async (body) => {
              let resJson = await body.json();
              let auxRowsIds = resJson.res.map((o) => o.id);
              setSelectedRows(
                auxRowsIds.filter((a) => !selectedRows.includes(a))
              );
              setIsLoading(false);
            },
            (error) => {
              setIsLoading(false);
            },
            {
              method: 'POST',
              body: JSON.stringify({
                filters: filterValuesOnlyAssetsActive,
                outputFields: ['id'],
                eventType: props.event?.eventType,
                boxType: selectedBox.subtype,
              }),
            }
          );
          break;
        case 'some':
          setIsLoading(true);
          ApiFetch(
            props.statePath === 'transferredAssets' ||
              models?.eventInAssetTransferred?.includes(props.event?.eventType)
              ? `${props.url}/0/-1/${sortModel[0].field}/${sortModel[0].sort}/transferred/${selectedBox.id}/${props.event?.eventType}`
              : `${props.url}/0/${someValue}/${sortModel[0].field}/${sortModel[0].sort}/active`, // page:0 y pageSize: -1 === all registers
            globalContext,
            true,
            async (body) => {
              let resJson = await body.json();
              let auxRowsIds = resJson.res.map((o) => o.id);
              setSelectedRows(auxRowsIds);
              setIsLoading(false);
            },
            (error) => {
              setIsLoading(false);
            },
            {
              method: 'POST',
              body: JSON.stringify({
                filters: filterValuesOnlyAssetsActive,
                outputFields: ['id'],
                eventType: props.event?.eventType,
                boxType: selectedBox.subtype,
              }),
            }
          );
          break;
        default:
          break;
      }
    } else {
      let auxSelectedRows = [...selectedRows];
      let index = auxSelectedRows.findIndex((v) => v === value);
      index === -1
        ? auxSelectedRows.push(value)
        : auxSelectedRows.splice(index, 1);
      setSelectedRows(auxSelectedRows);
    }
  };

  function CustomNoRowsOverlay() {
    return (
      <div
        className="norows"
        style={{
          display: 'flex',
          width: '100%',
          alignItems: 'center',
          justifyContent: 'center',
          paddingTop: '20px',
        }}>
        {filterValues.length === 1
          ? t('largeGrid.msg.noDataLevel')
          : t('largeGrid.msg.noDataFilter')}
      </div>
    );
  }

  return (
    <div style={{ height: 'auto', width: '100%' }}>
      <PopoverErrorMesssage
        errorId={null}
        errorOpen={errorOpen}
        errorCell={errorCell}
        closeError={closeError}
        error={[t('largeGrid.msg.paused')]}
      />

      <AssetValidationFilter
        selectedBox={selectedBox}
        selectedCompany={props.selectedCompany}
        entity={props.entity}
        fields={props.fields}
        filterValues={filterValues}
        fieldsToHide={fieldsToHide}
        columns={columns.filter((c) => c.headerName.length > 0 && !c.hide)}
        setFilterValues={setFilterValues}
        setFilterValuesLoaded={setFilterValuesLoaded}
        sessionContext={props.sessionContext}
        urlBoxesLots={
          props.statePath === 'transferredAssets' ||
          models?.eventInAssetTransferred?.includes(props.event?.eventType)
            ? `boxes/${selectedBox.id}/lots_transferred/${selectedAsset.id}/${props.event?.eventType}`
            : `boxes/${selectedBox.id}/lots`
        }
      />

      {props.show && isInit && (
        <>
          <Grid
            container
            sx={{ p: 2, mb: 4, mt: 2, alignItems: 'center' }}
            style={{ margin: '16px', padding: 0 }}>
            <Grid item sx={{ pr: 2 }} xs={4}>
              <div
                style={{
                  paddingLeft: '10px',
                  color: '#6d6d6d',
                  fontSize: '0.9rem',
                }}>
                {t('largeGrid.title')}
                {selectedRows.length}
              </div>
            </Grid>
            <Grid
              item
              xs={8}
              sx={{
                pr: 2,
                display: 'flex',
                width: '100%',
                justifyContent: 'flex-end',
                gap: 1,
              }}>
              {props.validateAssetsButton && props.validateAssetsButton}
              <Button
                variant={'outlined'}
                onClick={async () => {
                  await loadServerRows(
                    rowsState.page,
                    rowsState.pageSize,
                    sortModel[0]
                  );
                }}>
                {t('largeGrid.button.reload')}
              </Button>
              <SplitButton
                variant={'outlined'}
                options={[
                  {
                    label: t('largeGrid.button.select.none'),
                    key: 'none',
                    withValue: false,
                  },
                  {
                    label: t('largeGrid.button.select.all'),
                    key: 'all',
                    withValue: false,
                  },
                  {
                    label: t('largeGrid.button.select.invert'),
                    key: 'invert',
                    withValue: false,
                  },
                  {
                    label: t('largeGrid.button.select.some'),
                    key: 'some',
                    withValue: true,
                  },
                ]}
                handleClick={(e, v) => {
                  setSelectedOption(e);
                  setSomeValue(v);
                }}
              />
            </Grid>
          </Grid>
          <DataGrid
            className="data-grid-custom-pagination"
            sx={{
              height: '23rem',
              overflowY: 'auto',
              ...(props.lotAssetsEdit !== undefined &&
                !props.lotAssetsEdit && {
                  '& .MuiDataGrid-row': {
                    pointerEvents: 'none',
                    opacity: 0.5,
                  },
                }),
            }}
            autoHeight={false}
            rows={isLoading ? [] : rows}
            columns={columns}
            disableSelectionOnClick
            disableColumnMenu
            rowCount={rowCountState}
            loading={isLoading}
            pagination
            {...rowsState}
            paginationMode="server"
            onPageChange={(page) => setRowsState((prev) => ({ ...prev, page }))}
            sortingMode="server"
            sortModel={sortModel}
            onSortModelChange={handleSortModelChange}
            hideFooterSelectedRowCount={true}
            components={{
              NoRowsOverlay: CustomNoRowsOverlay,
            }}
            componentsProps={{
              toolbar: {
                printOptions: { disableToolbarButton: true },
              },
            }}
            pageSize={pageSizeDGs}
            rowsPerPageOptions={constPaginationDataGrid.defaultPageSizesArray}
            onPageSizeChange={(newPageSize) => {
              setPageSizeDGs(newPageSize);
              setRowsState((prev) => ({ ...prev, pageSize: newPageSize }));
            }}
          />
        </>
      )}
    </div>
  );
};

export default AssetValidationTable;
